import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  text-align: center;
  background-color: #f7fafc;
  padding: 2rem;
`;

const SuccessIcon = styled.div`
  color: #48bb78;
  font-size: 4rem;
  margin-bottom: 1.5rem;
`;

const SuccessTitle = styled.h2`
  font-size: 2.5rem;
  color: #2d3748;
  margin-bottom: 1rem;
`;

const SuccessMessage = styled.p`
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 2rem;
  max-width: 600px;
  line-height: 1.6;
`;

const StyledLink = styled(Link)`
  display: inline-block;
  padding: 0.8rem 1.5rem;
  background-color: #4299e1;
  color: white;
  border-radius: 0.375rem;
  text-decoration: none;
  font-weight: 600;
  transition: background-color 0.2s;

  &:hover {
    background-color: #3182ce;
  }
`;

export const RegistrationSuccessPage: React.FC = () => {
  return (
    <SuccessContainer>
      <Helmet>
        <title>Registration Successful - Spin To Connect</title>
        <meta name="description" content="Your registration with Spin To Connect is complete. Start connecting and creating interactive experiences now!" />
      </Helmet>
      <SuccessIcon>
        <FontAwesomeIcon icon={faCheckCircle} />
      </SuccessIcon>
      <SuccessTitle>Registration Successful!</SuccessTitle>
      <SuccessMessage>
        Thank you for registering with SpinToConnect. Your account has been successfully created and your payment processed.
        You can now proceed to log in and start creating meaningful connections.
      </SuccessMessage>
      <StyledLink to="/admin/login">Go to Login</StyledLink>
    </SuccessContainer>
  );
};
